import { useEffect, useState } from 'react'

const getBadgeImage = (badgeCategory: string, badgeTier: number) => {
	const path = `assets/badges/${badgeCategory}/${badgeTier}.png`

	return new Promise<{ path: string; status: 'ok' | 'error' }>(resolve => {
		const img = new Image()
		img.onload = () => resolve({ path, status: 'ok' })
		img.onerror = () => resolve({ path, status: 'error' })

		img.src = path
	})
}

export const useBadgeImage = (badgeCategory: string, badgeTier: number) => {
	const [imagePath, setImagePath] = useState<string | null>(null)
	const [imageLoaded, setImageLoaded] = useState<boolean>(false)
	const [isLoading, setIsLoading] = useState<boolean>(true)

	useEffect(() => {
		const loadImage = async () => {
			setIsLoading(true)
			try {
				const result = await getBadgeImage(badgeCategory, badgeTier)
				if (result.status === 'ok') {
					setImagePath(result.path)
					setImageLoaded(true)
				} else {
					setImagePath(null)
					setImageLoaded(false)
				}
			} catch (error) {
				setImagePath(null)
				setImageLoaded(false)
			} finally {
				setIsLoading(false)
			}
		}

		loadImage()
	}, [badgeCategory, badgeTier])

	return {
		imagePath,
		imageLoaded,
		isLoading,
	}
}
